import customerService from '../Customer/service'
// import merchantService from "@/modules/Merchant/service.js";

export default {
  namespaced: true,
  state: {
    Customer: null,
    customerTab: null,
    customerList: []
  },
  getters: {
    getCustomer(state) {
      return state.Customer
    },
    getActiveTab(state) {
      return state.customerTab
    },
    customerList(state) {
      return state.customerList
    },
  },
  actions: {
    setCustomerList({
      commit
    }, payload) {
      commit('SETCUSTOMERLIST', payload)
    },
    setActiveTab({
      commit
    }, payload) {
      commit('SETACTIVETAB', payload)
    },
    setCustomer({
      commit
    }, id) {
      return customerService.getById(id)
        .then(async (response) => {
          // console.log('response customer by id', response)
          // if (response.data && !response.data.alert) response.data.alert = false
          // if (response.data.payCompassId) {
          //   console.log('response.payCompassId', response.data.payCompassId)
          //   // const merchantList = await merchantService.getByCustomerId()
          // }

          commit('SETCUSTOMER', response.data)
        }).catch(err => {
          return err
        })

    },
  },
  mutations: {
    SETCUSTOMERLIST(state, payload) {
      // console.log('setCustomer', payload)
      state.customerList = payload
    },
    SETACTIVETAB(state, payload) {
      state.customerTab = payload
    },
    SETCUSTOMER(state, payload) {

      if (payload) {
        document.title = `taleem - ${payload.name}`
        state.Customer = payload
      }
    },
  },
}